import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ValidatorFn, FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../services/general.service';
import { ServicingService } from '../../../../services/servicing.service';
import { ProjectService } from '../../../../services/project.service';
import { exit } from 'process';

declare var $: any;


const MyAwesomeRangeValidator: ValidatorFn = (fg: FormGroup) => {
  const repetition_option = fg.get('repetition_option').value;

  const repetitions_count = fg.get('repetitions_count').value;
  const repetitions_type = fg.get('repetitions_type').value;
  const days_notify = fg.get('days_notify').value;
  const notify_time = fg.get('notify_time').value;



  if (repetition_option == "1" || repetition_option == "2") {
    if (parseInt(days_notify) >= parseInt(repetitions_count)) {
      // console.log('test');
      var sa;
      if (repetitions_count != "") {
        sa = fg.get('repetitions_count').value;
      }
    
      var sb = repetitions_type;
      if (sb == "Weeks") {
        sa = sa * 7;
      }
      else if (sb == "Months") {
        sa = sa * 30;
      }
      else if (sb == "Years") {
        sa = sa * 365;
      }
  
      var common = new Date();
  
      var first = new Date();
      first.setDate(common.getDate() + parseInt(sa));
  
      // console.log(first);
      // console.log(second);
  
      var second = new Date();
      second.setDate(common.getDate() + parseInt(days_notify));

      // console.log(first);
      // console.log(second);

      return first > second ? null : { rangeval: true };
    }
  }
  
};



@Component({
  selector: 'app-projectclass_create',
  templateUrl: './projectclass_create.component.html',
  styleUrls: ['./projectclass_create.component.css']
})
export class AddprojectclassComponent implements OnInit {

  @Input() ID: string;
  @Input() langs: string;
  @Input() redirect: string;

  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  frequencyConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  maintenance_plans: any;
  notification_time: any;
  form_data: any;
  app_emp_id: any;
  lang: any;
  generalLang: any;
  record: any;
  mode: string;
  show: any;

  imageLink: any;
  redirect1: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private servicingService: ServicingService,
    private projectService: ProjectService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {

    // this.FormBuild();
    this.getData();

    this.config();
    this.fileDesign();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };



  }


  config(): void {



    this.frequencyConfig = [
      { value: 'Days', text: 'Days' },
      { value: 'Weeks', text: 'Weeks' },
      { value: 'Months', text: 'Months' },
      { value: 'Years', text: 'Years' }
    ];



  }

  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      class: ['', [Validators.required]],
      category: ['', [Validators.required]],
      description: ['', [Validators.required]],
      repetition_option: ['0'],
      repetitions_count: [''],
      repetitions_type: [''],
      days_notify: [''],
      notify_time: [''],
      class_id: '',
      action: 'update',
    }, { validator: MyAwesomeRangeValidator });


    this.createForm.get("repetition_option").valueChanges
    .subscribe(data=> {
      this.changeValidators()
    })

  }

  FormBuildUpdate(): void {

    this.createForm.patchValue({
      class: this.record.class,
      category: this.record.category,
      description: this.record.description,
      repetition_option: this.record.repetition_option,
      repetitions_count: this.record.repetitions_count,
      repetitions_type: this.record.repetitions_type,
      days_notify: this.record.days_notify,
      notify_time: this.record.notify_time,
      class_id: this.record.class_id,
      action: 'update',

    });


  }

  fileDesign() {
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  imagePreview(value) {

    this.imageLink = value;
    this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }


  onSubmit() {

    // console.log(this.createForm.value); return false;

    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

    //   console.log('test12'); return false;

    this.projectService.update_projectclass(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();

          if (this.redirect1 == "") {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.PROJECT_CLASS]);
              });
          }
          else {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.PROJECT_CLASS]);
          });
          }
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }



  // getData() {

  //   if (this.ID) 
  //   {
  //   this.mode = 'Edit';
  //   this.modalTitle = 'Edit Servicing';
  //   }
  //   else 
  //   {
  //   this.mode = 'Create';
  //   this.modalTitle = 'Create Servicing';
  //   }
  // }

  getData() {
    if (this.ID) {
      this.projectService.editProjectClass(this.ID).subscribe(
        res => {

          if (!res.status) {
            this.generalService.notify_msg('error', 'Some problems in getting details');
            this.bsModalRef.hide();
            return;
          }
          // this.lang = res.data.language;
          // this.record = res.data.record;
          // this.app_emp_id = res.data.record.emp_id1;
          this.notification_time = res.data.notification_time;
          this.record = res.data.form_data;
          this.FormBuildUpdate();

          if (this.record.repetition_option == '1')
          {
            $('.reptition_child').show();
          }


        }
      );





      this.generalLang = this.langs;
      this.redirect1 = this.redirect;

      this.mode = 'Edit';
      this.modalTitle = this.generalLang.editprojectclass;
    }
    else {

      this.projectService.getProjectclassList()
        .subscribe(
          (res) => {
            // this.lang = this.servicingService.createLang(res);
            // this.app_emp_id = res.data.emp_id;
            // this.app_maintenance_plans = res.data.app_maintenance_plans;
            // console.log(this.app_maintenance_plans);
            this.notification_time = res.data.notification_time;

          }
        );


      this.generalLang = this.langs;
      this.redirect1 = '';

      this.modalTitle = this.generalLang.addprojectclass;


    }


    this.createFormErrorMsg = {
      'class': [{ type: 'required', message: this.generalLang.requiredField }],
      'category': [{ type: 'required', message: this.generalLang.requiredField }],
      'description': [{ type: 'required', message: this.generalLang.requiredField }],
      'repetitions_count': [{ type: 'required', message: this.generalLang.requiredField }],
      'repetitions_type': [{ type: 'required', message: this.generalLang.requiredField }],
      'days_notify': [{ type: 'required', message: this.generalLang.requiredField }],
      'notify_time': [{ type: 'required', message: this.generalLang.requiredField }],
    }

    this.FormBuild();

  }

  setRequired() {
		return [Validators.required];
	}


  show_child(id:any)
  {
    if (id == '1')
    {
      $('.reptition_child').show();
      
    }
    else
    {
      $('.reptition_child').hide();
    }

  }



  changeValidators() {
    
    // console.log(this.createForm.get("repetition_option").value)
 
    if (this.createForm.get("repetition_option").value=="1") {
      this.createForm.controls["repetitions_count"].setValidators([Validators.required]);
      this.createForm.controls["repetitions_type"].setValidators([Validators.required]);
      this.createForm.controls["days_notify"].setValidators([Validators.required]);
      this.createForm.controls["notify_time"].setValidators([Validators.required]);
    } else {
      this.createForm.controls["repetitions_count"].clearValidators();
      this.createForm.controls["repetitions_type"].clearValidators();
      this.createForm.controls["days_notify"].clearValidators();
      this.createForm.controls["notify_time"].clearValidators();
    }
 
    this.createForm.get("repetitions_count").updateValueAndValidity();
    this.createForm.get("repetitions_type").updateValueAndValidity();
    this.createForm.get("days_notify").updateValueAndValidity();
    this.createForm.get("notify_time").updateValueAndValidity();
 
       
  }



}
